let KadRedactor = new function() {
  var self = {};

  self.config = {};

  self.changeCallback = function() {
    // 'this' is the redactor instance on your textarea
    // Force KO Value binding updates
    this.$element.trigger('change');
  };

  self.sourceCallback = function(html) {
    // Triggering the syntax plugin to init
    this.$element.trigger('redactor.sourceCallback');
  };

  self.visualCallback = function(html) {
    // Triggering the syntax plugin to cleanup
    this.$element.trigger('redactor.visualCallback');
  };

  // http://imperavi.com/redactor/docs/settings
  // All module configs must extend this base config
  self.config.base = {
    plugins: ['codeEditor', 'fullscreen', 'fontcolor', 'syntax'],
    formatting: ['p', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h4'],
    buttonsHideOnMobile: [ 'image', 'video', 'file', 'embed' ],
    toolbarFixed: false,
    linkSize: 500, // Links get automatically truncated, this is to avoid that
    minHeight: 166,
    maxHeight: 300,
    source: true,
    // focus: true,
    sourceCallback: self.sourceCallback,
    visualCallback: self.visualCallback,
    changeCallback: self.changeCallback
  };

  // These are considered 'module' configs
  // they enable features / plugins. Multiple
  // can be combined on an editor by providing a comma
  // separated list like: data-redactor-modules = "images,files,source"

  // data-redactor-modules = "limiter"
  // sets character limit
  self.config.limiter = _.extend({}, self.config.base, {
    plugins: _.union(self.config.base.plugins, ['limiter'])
  });


  // data-redactor-modules = "code"
  // enables code editor modal
  self.config.code = _.extend({}, self.config.base, {
    plugins: _.union(self.config.base.plugins, ['codeEditor'])
  });

  // data-redactor-modules = "fontcolor"
  // enables fontcolor plugin
  self.config.fontcolor = _.extend({}, self.config.base, {
    plugins: _.union(self.config.base.plugins, ['fontcolor'])
  });

  // data-redactor-modules = "source"
  // enables source code editing with ace editor
  self.config.source = _.extend({}, self.config.base, {
    plugins: _.union(self.config.base.plugins, ['syntax']),
    source: true,
    sourceCallback: self.sourceCallback,
    visualCallback: self.visualCallback
  });

  // data-redactor-modules = "video"
  // enables video embedding
  self.config.video = _.extend({}, self.config.base, {
    plugins: _.union(self.config.base.plugins, ['video'])
  });

  // data-redactor-modules = "embed"
  // enables iframe embedding
  self.config.embed = _.extend({}, self.config.base, {
    plugins: _.union(self.config.base.plugins, ['embed'])
  });

  // data-redactor-modules = "alert"
  // limited option config for site alerts editor
  self.config.alert = _.extend({}, self.config.base, {
    plugins: [],
    buttonsHide: ['unorderedlist', 'orderedlist', 'outdent', 'indent', 'formatting', 'alignment', 'html', 'horizontalrule'],
    convertVideoLinks: false,
    convertImageLinks: false
  });

  // data-redactor-modules = "heading"
  // Limited config for section titles in course syllabus
  self.config.heading = _.extend({}, self.config.base, {
    plugins: [],
    minHeight: 80,
    maxHeight: 80,
    buttonsHide: ['unorderedlist', 'orderedlist', 'outdent', 'indent', 'alignment', 'html', 'horizontalrule', 'link']
  });

  // Styles don't need to inherit from base
  // these configs should only affect the appearance
  // of the editor, not enable plugins or features

  // data-redactor-style = "medium"
  self.config.medium = {
    minHeight: 300,
    maxHeight: 300
  };

  // data-redactor-style = ""
  self.config.dropzone_adj = {
    minHeight: 238,
    maxHeight: 238
  };

  // data-redactor-style = "short"
  self.config.short = {
    minHeight: 166,
    maxHeight: 166
  };

  // data-redactor-style = "minimal"
  self.config.minimal = {
    minHeight: 166,
    maxHeight: 166,
    buttons: [
      'formatting',
      'bold',
      'italic',
      'deleted',
      'link'
    ]
  };

  // data-redactor-style = "html"
  self.config.html = {
    plugins: [],
    minHeight: 166,
    maxHeight: 166,
    buttons: [
      'html'
    ]
  };

  return {
    config: self.config,

    init: function(node, options) {
      Kadenze.onModuleLoaded('Util', () => {
        self.routes = {
          imageUpload: Kadenze.Routes.redactor_rails_pictures_path() + '?' + Kadenze.Util.getCSRFQueryString(),
          imageGetJson: Kadenze.Routes.redactor_rails_pictures_path(),
          fileUpload: Kadenze.Routes.redactor_rails_documents_path() + '?' + Kadenze.Util.getCSRFQueryString(),
          fileGetJson: Kadenze.Routes.redactor_rails_documents_path()
        };

        // data-redactor-modules = "images"
        // enables image uploads
        self.config.images = _.extend({}, self.config.base, {
          imageUpload: self.routes.imageUpload,
          imageGetJson: self.routes.imageGetJson
        });

        // data-redactor-modules = "files"
        // enables file uploads
        self.config.files = _.extend({}, self.config.base, {
          fileUpload: self.routes.fileUpload,
          fileGetJson: self.routes.fileGetJson
        });

        var $node = $(node),
          params = _.extend({}, KadRedactor.utils.getConfig(node), options);

        // Only init if we haven't already
        if(!$node.data('redactorInitialized')) {

          // If we haven't initialized but this class exists
          // we are dealing with a cached editor from PJAX
          // and the cached nodes must be cleaned up
          if($node.hasClass('js-redactor-initialized')) {
            $node = KadRedactor.utils.clean(node);
          }

          KadRedactor.create($node, params);
        }
      });
    },

    // Actually calls redactor on $node with params
    create: function($node, params) {
      console.log('Redactor: Initializing with:');
      console.log(params);

      $node.redactor(params);

      $node.addClass('js-redactor-initialized');
      $node.data('redactorInitialized', true);
    }
  };

}; // End KadRedactor

KadRedactor.utils = {

  getConfig: function(node) {
    var style = this.getStyle(node);
    var modules = this.getModules(node);
    var options = this.getOptions(node);

    if(!modules) {
      // Since modules inherit from base, if none are specified
      // we need to still extend from base. This allows you to
      // specify a style ONLY, or nothing at all and still maintain our base config.
      modules = KadRedactor.config.base;
    }

    return _.extend({}, modules, style, options);
  },

  // Select style based on data attribute of the node
  getStyle: function(node) {
    var $node = $(node);

    if($node.data('redactorStyle')) {
      return KadRedactor.config[$node.data('redactorStyle')];
    }
  },

  // Get modules based on data attribute of the node.
  // You can specify multiple modules by separating each
  // with a comma, i.e. data-redactor-modules = 'images,files,source'
  getModules: function(node) {
    var $node = $(node);

    if($node.data('redactorModules')) {
      var modules = $node.data('redactorModules').split(','),
        merged = {};

      _.each(modules, function(module) {
        _.unionExtend(merged, KadRedactor.config[module]);
      });

      return merged;
    }
  },

  getOptions: function(node) {
    var $node = $(node);
    var options = {};

    if($node.data('redactorOptions')) {
      options = $node.data('redactorOptions');
    }

    return options;
  },

  // Used to manually clean up redactor markup, addresses PJAX back/forward cache
  clean: function(node) {
    console.log('Redactor: Cleaning up PJAX cache');

    var $node = $(node),
      $box = $node.parents('.redactor-box'),
      $editor = $box.find('.redactor-editor'),
      $toolbar = $box.find('.redactor-toolbar');

    $node.unwrap();
    $box.remove();
    $editor.remove();
    $toolbar.remove();

    $('.redactor-toolbar-tooltip').remove();

    return $node;
  },

  // If syntax highlighting has been applied, this will restore it by
  // un-escaping pre blocks, as redactor escapes them by default when
  // setting the value of the editor.
  renderPreTags: function($editor) {
    var $preTags = $editor.children('pre');

    if($preTags.length) {
      console.log('Redactor: rendering ' + $preTags.length + ' pre tag(s)');
      $editor.children('pre').each(function() { KadRedactor.utils.cleanInnerHtml($(this)); });
    }
  },

  // Removes all HTML within a node while preserving the text content
  cleanInnerHtml: function($node) {
    return $node.html($node.text());
  }

}; // End KadRedactor.utils

export default KadRedactor;
